import {
  Box,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import LineChart from "components/charts/LineChart";
import React from "react";
import { RiArrowUpSFill } from "react-icons/ri";
import { lineChartOptionsTotalSpent } from "variables/charts";

export default function TotalSpent(props) {
  const { revenueData = [], labels = [] } = props;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const secondaryText = useColorModeValue("gray.500", "gray.400");

  const last = revenueData[revenueData.length - 1] || 0;
  const prev = revenueData[revenueData.length - 2] || 0;

  const change = last - prev;

  let percent = 0;
  if (prev > 0) {
    percent = (change / prev) * 100;
  }

  if (prev < 5) {
    percent = 0;
  }

  const isPositive = change >= 0;

  const total = revenueData.reduce((a, b) => a + b, 0);

  return (
    <Card direction="column" w="100%" p="20px">
      <Flex justify="space-between" align="center" mb="12px">
        <Flex direction="column">
          <Text fontSize="sm" color={secondaryText}>
            Last 7 days
          </Text>
          <Text fontSize="28px" fontWeight="700" color={textColor}>
            {total.toLocaleString()}
          </Text>
        </Flex>

        <Flex align="center" gap="6px">
          <Icon
            as={RiArrowUpSFill}
            color={isPositive ? "green.400" : "red.400"}
            transform={isPositive ? "rotate(0deg)" : "rotate(180deg)"}
          />
          <Text
            color={isPositive ? "green.400" : "red.400"}
            fontSize="sm"
            fontWeight="600"
          >
            {prev === 0
              ? "--"
              : `${isPositive ? "+" : ""}${change} (${percent.toFixed(1)}%)`}
          </Text>
        </Flex>
      </Flex>

      <Box h="260px">
        <LineChart
          chartData={[
            {
              name: "Requests",
              data: revenueData.map(Number),
            },
          ]}
          chartOptions={{
            ...lineChartOptionsTotalSpent,
            colors: [isPositive ? "#22c55e" : "#ef4444"],
            xaxis: {
              ...lineChartOptionsTotalSpent.xaxis,
              categories: labels,
            },
          }}
        />
      </Box>
    </Card>
  );
}
